import get from 'lodash/get';
import { CREATE_PROJECT, CREATE_PROJECT_SUCCESS, CREATE_PROJECT_FAILURE, FETCH_PROJECT_LIST, FETCH_PROJECT_LIST_SUCCESS, FETCH_PROJECT_LIST_FAILURE, UPDATE_PROJECT, UPDATE_PROJECT_SUCCESS, UPDATE_PROJECT_FAILURE } from "./types";
const initialState = {
  isProjectCreationLoading: false,
  isProjectListLoading: false,
  isProjectUpdateLoading: false,
};
const ProjectReducer = (state = initialState, action) => {

  switch (action.type) {

    case CREATE_PROJECT: {
      return {
        ...state,
        isProjectCreationLoading: true
      };
    }
    case CREATE_PROJECT_SUCCESS: {
      return {
        ...state,
        isProjectCreationLoading: false 
      }
    }
    case CREATE_PROJECT_FAILURE: {
      return {
        ...state,
        isProjectCreationLoading: false
      }
    }
    case FETCH_PROJECT_LIST: {
      return {
        ...state,
        isProjectListLoading: true,
      };
    }
    case FETCH_PROJECT_LIST_SUCCESS: {  
      const resData = get(action, 'responseData', []);
      return {
        ...state,
        ProjectList: resData.data,
        isProjectListLoading: false
      }
    }
    case FETCH_PROJECT_LIST_FAILURE: {
      return {
        ...state,
        isProjectListLoading: false
      }
    }
    case UPDATE_PROJECT: {
      return {
        ...state,
        isProjectUpdateLoading: true,
      };
    }
    case UPDATE_PROJECT_SUCCESS: {  
      const updatedProject = get(action, 'responseData', {});
      const projectList = get(state, 'ProjectList', []);
      
      // Update the project in the list
      const updatedProjectList = projectList.map(project => 
        project.id === updatedProject.id ? updatedProject : project
      );
      
      return {
        ...state,
        ProjectList: updatedProjectList,
        isProjectUpdateLoading: false
      }
    }
    case UPDATE_PROJECT_FAILURE: {
      return {
        ...state,
        isProjectUpdateLoading: false
      }
    }
   
  

    default: {
      return state;
    }
  }
};

export default ProjectReducer;